/* ==========================================================================
   00FIERCE — PLUS-BUTTON (Glas-Kachel) · Okt 2026
   Gehoert zu snippets/khs-quick-add.liquid und assets/khs-card-glass.css.
   Wird nur geladen, wenn 00F Kacheln > Stil = Glas-Kapsel und der
   Plus-Button an ist.

   · Faengt die Formulare [data-khs-qa] ab und legt ohne Seitenwechsel in
     den Warenkorb, genau wie product-form.js auf der Produktseite
     (gleiche Sections, gleiche cart-notification).
   · Gibt es keine cart-notification oder kein fetch, laeuft das Formular
     ganz normal an /cart/add (Warenkorb-Seite) — nichts geht verloren.
   · Delegiert ueber document, funktioniert also auch nach dem Neuladen
     des Rasters durch Filter (facets.js).
   ========================================================================== */
(function () {
  'use strict';

  if (window.__khsQuickAdd) return;
  window.__khsQuickAdd = true;

  /* Der Kachel-Druckeffekt (khs-kinetic.js, pointerdown auf .card-wrapper)
     soll beim Tippen aufs Plus nicht ausloesen. */
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.khs-qa')) e.stopPropagation();
  }, true);

  function closeSheets(except) {
    document.querySelectorAll('.khs-qa__pick[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  /* Auswahl schliessen: Tipp daneben oder Escape */
  document.addEventListener('click', function (e) {
    var pick = e.target.closest ? e.target.closest('.khs-qa__pick') : null;
    closeSheets(pick);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSheets(null);
  });

  function showError(qa, text) {
    if (!qa) return;
    var old = qa.querySelector('.khs-qa__err');
    if (old) old.remove();
    var el = document.createElement('p');
    el.className = 'khs-qa__err';
    el.setAttribute('role', 'alert');
    el.textContent = text || (window.cartStrings && window.cartStrings.error) || 'Hat nicht geklappt. Bitte nochmal versuchen.';
    qa.appendChild(el);
    setTimeout(function () { el.remove(); }, 3500);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-khs-qa]')) return;

    var cn = document.querySelector('cart-notification');
    if (!window.fetch || !window.FormData || !cn ||
        typeof cn.renderContents !== 'function' || typeof cn.getSectionsToRender !== 'function') {
      return; /* normaler Formular-Versand an /cart/add */
    }
    e.preventDefault();

    var qa = form.closest('.khs-qa');
    var pick = form.closest('.khs-qa__pick');
    var trigger = e.submitter || form.querySelector('[type="submit"]');
    var visual = pick ? pick.querySelector('.khs-qa__btn') : trigger;
    if (!visual || visual.classList.contains('is-loading')) return;

    visual.classList.add('is-loading');
    visual.setAttribute('aria-busy', 'true');
    if (trigger && trigger !== visual) trigger.classList.add('is-loading');
    if (typeof cn.setActiveElement === 'function') cn.setActiveElement(visual);

    var body = new FormData(form);
    body.append('sections', cn.getSectionsToRender().map(function (s) { return s.id; }));
    body.append('sections_url', window.location.pathname);

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          showError(qa, res.description || res.message);
          return;
        }
        if (pick) pick.removeAttribute('open');
        visual.classList.add('is-added');
        setTimeout(function () { visual.classList.remove('is-added'); }, 1400);
        cn.renderContents(res);
      })
      .catch(function () {
        /* Netz weg oder Antwort kaputt: klassisch abschicken */
        form.submit();
      })
      .finally(function () {
        visual.classList.remove('is-loading');
        visual.removeAttribute('aria-busy');
        if (trigger) trigger.classList.remove('is-loading');
      });
  });
})();
